export default __webpack_public_path__ + "static/media/satellite.aeab1d40.svg";